import * as React from 'react'

import { Box, Dimensions, Icon, Text } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Report from 'modules/reports/store/models/Report'

interface Props {
  option: SelectOption
  onSelect?: (value: string) => void
  style?: Record<string, Dimensions>
  defaultSelector?: boolean
}

const getChartType = (value: string) => {
  switch (value) {
    case 'area':
      return i18n.t('reports.chart_type.area')
    case 'bars':
      return i18n.t('reports.chart_type.bars')
    case 'lines':
      return i18n.t('reports.chart_type.lines')
    case 'numeric_metric':
      return i18n.t('reports.chart_type.numeric_metric')
    case 'pie':
      return i18n.t('reports.chart_type.pie')
    case 'scatterplot':
      return i18n.t('reports.chart_type.scatterplot')
    case 'table':
      return i18n.t('reports.chart_type.table')
    default:
      throw new Error(`Unknown chart type: ${value}`)
  }
}

const Option = ({ option, onSelect, style, defaultSelector }: Props) => {
  const [toggle, setToggle] = React.useState(false)

  const changeToggle = () => {
    if (!defaultSelector) setToggle(!toggle)
  }

  const icon = Report.ICONS[option.value]

  return (
    <>
      <Box
        onPointerEnter={changeToggle}
        onPointerLeave={changeToggle}
        onClick={() => {
          if (onSelect) {
            onSelect(option.value)
          }
        }}
        justifyContent="spaceBetween"
        flexDirection="row"
        flexGrow
      >
        <Box
          gap="s8"
          background={toggle ? 'grey100' : 'grey000White'}
          paddingBottom={style?.paddingBottom || 's8'}
          paddingTop={style?.paddingTop || 's8'}
          borderRadius={{ all: 'abs008' }}
          flexDirection="row"
          flexGrow
        >
          <Box width="s40" paddingLeft="s4">
            {icon && <Icon.Large icon={icon} color="radicalRed1000" />}
          </Box>
          <Box paddingTop="s4" paddingLeft="s4">
            <Text.Normal>{getChartType(option.value)}</Text.Normal>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Option
